<template>
	<div class="product-video__wrapper">
		<div ref="WL_Video" class="product-video"></div>
	</div>
</template>
<script>
	import { mapGetters } from 'vuex'
	import { currency } from '@/lib'
	export default {
		data() {
			return {}
		},
		mounted() {
			let WLBenefit, columnHeaders;
            let columnTable = {
                Rows: {
                    Row: []
                }
            }
			if (Array.isArray(this.product.WLInsureds.WLInsured[0].Tables.Table.ColumnTable)) {
                // Employlee Non-Tobacco
				this.product.WLInsureds.WLInsured[0].Tables.Table.ColumnTable.forEach(col => {
                    columnTable.Rows.Row = [...columnTable.Rows.Row, ...col.Rows.Row]
                })
				if (Array.isArray(this.product.WLInsureds.WLInsured[1].Tables.Table.ColumnTable)) {
					this.product.WLInsureds.WLInsured[1].Tables.Table.ColumnTable.forEach(col => {
						columnTable.Rows.Row = [...columnTable.Rows.Row, ...col.Rows.Row]
					})
				} else {
					columnTable.Rows.Row = [...columnTable.Rows.Row, ...this.product.WLInsureds.WLInsured[1].Tables.Table.ColumnTable.Rows.Row]
				}

                columnHeaders = this.product.WLInsureds.WLInsured[0].Tables.Table.ColumnTable[this.product.WLInsureds.WLInsured[0].Tables.Table.ColumnTable.length - 1]
			} else {
				columnTable.Rows.Row = [
                    ...this.product.WLInsureds.WLInsured[0].Tables.Table.ColumnTable.Rows.Row, 
                    ...this.product.WLInsureds.WLInsured[1].Tables.Table.ColumnTable.Rows.Row
                ]
                columnHeaders = this.product.WLInsureds.WLInsured[0].Tables.Table.ColumnTable
			}
			if (this.product.WLInsureds.WLInsured[1].PurchaseType === 'Money Purchase') {
				// Get the highest benefit amount from the table
				WLBenefit = columnTable.Rows.Row.map(row => {
					return Object.entries(row)
						.filter(([key, value]) => key.search('Column') > -1 && value !== '($1)' && value !== null)
						.map(([_, value]) => value)
						.sort((a, b) => currency.format.number(b) - currency.format.number(a))[0]
				}).sort((a, b) => currency.format.number(b) - currency.format.number(a))[0]
				WLBenefit = currency.format.number(WLBenefit)
			} else {
				WLBenefit = Object.values(columnHeaders.Rows.Row[0])
					.filter(val => val && val !== 'Age')
					.sort((a, b) => currency.format.number(b) - currency.format.number(a))[0]
				WLBenefit = currency.format.number(WLBenefit)
			}
			let blueRushVideoScript = document.createElement('script')
			blueRushVideoScript.setAttribute('src', 'https://d2ur3inljr7jwd.cloudfront.net/individeo/prod/edge/js/smartEmbed.js')
			blueRushVideoScript.setAttribute('data-iv-attachment-code', process.env.VUE_APP_BLUE_RUSH_ENV_WL)
			blueRushVideoScript.setAttribute('data-iv-lang', 'en-US')
			blueRushVideoScript.setAttribute('data-iv-use-branding', 'false')
			blueRushVideoScript.setAttribute('data-bp-enable-company-signature', 'false')
			blueRushVideoScript.setAttribute('data-bp-embed-smart-tracking', 'true')
			blueRushVideoScript.setAttribute(
				'data-iv-individeo-data',
				JSON.stringify({
					Broker: this.agent.Name,
					Employer: this.employer.Name,
					WLBenefit: WLBenefit,
					CTAbutton: `${window.location.origin}/pdf/${this.$route.params.id}`
				})
			)
			this.$refs.WL_Video.appendChild(blueRushVideoScript)
		},
		computed: {
			...mapGetters({
				proposalId: 'getProposalId',
				product: 'getWholeLife',
				employer: 'getEmployer',
				agent: 'getAgent'
			})
		},
		methods: {}
	}
</script>
<style lang="scss" scoped>
	.product-video__wrapper {
		position: relative;
		width: 100%;
		padding-bottom: calc(56.25% - 6px);
		border: 5px solid $gray;
		background: #ffffff;
	}
	.product-video {
		height: 0;
		width: 100%;
	}
</style>
